import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../../../../../services/api.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AssetType } from '../../../../../../admin/asset-types/shared/types';
import { arr_count, arr_filter, arr_map, arr_some, blank, data_get, fallback, filled, map_to_arr, observe, when } from '../../../../../../shared/utils/common';
import { ClientStoreService } from '../../../../../../services/client-store.service';
import { ViewService } from '../../../../../../services/view.service';
import { DialogService, DIALOG_DATA } from '../../../../../../services/dialog.service';
import { PaginatedResult, Pagination, PaginationStore } from '../../../../../../shared/store/pagination.store';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'documents-job-report-dialog',
  template: `
    <fieldmagic-dialog
      label="Job Report"
      icon="file-pdf"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          icon="file-pdf"
          label="Preview"
          (click)="onPreview()"
          [disabled]="fetching$ | async"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div class="d-flex d-flex-gap flex-column">
          <ng-container *ngIf="fetching$ | async">
            <div class="w-100 d-flex justify-content-center">
              <fieldmagic-icon [spin]="true"></fieldmagic-icon>
            </div>
          </ng-container>

          <ng-container *ngIf="!(fetching$ | async)">
              <ng-container *ngIf="paginated$ | async as types">
                <fieldmagic-pagination-links
                  *ngIf="types | filled"
                  [hideRefresh]="true"
                  [topOnly]="true"
                >
                  <table
                    class="table table-bordered"
                  >
                    <thead>
                      <tr>
                        <td width="98%">
                          <fieldmagic-text
                            purpose="table-header"
                            content="Asset Types"
                          >
                          </fieldmagic-text>
                        </td>

                        <td width="2%">
                          <fieldmagic-checkbox-input
                            [useNative]="true"
                            [(ngModel)]="all"
                            tooltip="Click to select/unselect all"
                            (ngModelChange)="onSelectAll($event)"
                          ></fieldmagic-checkbox-input>
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      <ng-container *ngIf="! (fetching$ | async)">
                        <ng-container *ngIf="paginated$ | async as types">
                          <tr
                            *ngIf="types | blank"
                            class="text-center"
                          >
                            <td colspan="2">{{ 'No available asset types' | translate }}</td>
                          </tr>

                          <ng-container *ngIf="types | filled">
                            <tr *ngFor="let type of types; let type_index = index">
                              <td>{{ type.name }}</td>
                              <td>
                                <fieldmagic-checkbox-input
                                  [useNative]="true"
                                  [(ngModel)]="type.selected"
                                  (ngModelChange)="onAssetSelect(type_index, $event)"
                                  tooltip="Click to select/unselect"
                                >
                                </fieldmagic-checkbox-input>
                              </td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tbody>
                  </table>
                </fieldmagic-pagination-links>
              </ng-container>

            <table class="table table-bordered">
              <thead>
                <tr>
                  <td width="98%">
                    <fieldmagic-text
                      content="What would you like to include?"
                      purpose="table-header"
                    >
                    </fieldmagic-text>
                  </td>
                  <td width="2%">
                    <fieldmagic-checkbox-input
                      [(ngModel)]="include"
                      [useNative]="true"
                      tooltip="Click to select/unselect all"
                      (ngModelChange)="onIncludingAll($event)"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{{ 'Work Order' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showWorkOrder"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Time Entries' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showTimeEntries"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Materials' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showMaterials"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Notes' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showWorkNotes"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Completed Tasks' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showTasks"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Photos' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="showPhotos"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'Job Checklists' | translate }}</td>
                  <td>
                    <fieldmagic-checkbox-input
                      [(ngModel)]="includeJobChecklists"
                      [useNative]="true"
                      tooltip="Click to select/unselect"
                      (ngModelChange)="onInclusionToggle()"
                    >
                    </fieldmagic-checkbox-input>
                  </td>
                </tr>

                <ng-container *ngIf="types$ | async as types">
                  <tr *ngIf="types | filled">
                    <td>{{ 'Failed Assets Only' | translate }}</td>
                    <td>
                      <fieldmagic-checkbox-input
                        [(ngModel)]="failAssetsOnly"
                        [useNative]="true"
                        tooltip="Click to select/unselect"
                        (ngModelChange)="onInclusionToggle()"
                      >
                      </fieldmagic-checkbox-input>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  `,
  providers: [
    PaginationStore,
  ]
})
export class JobReportDialogComponent implements OnInit, OnDestroy {
  all: boolean = true;
  include: boolean = true;

  showWorkOrder: boolean = false;
  showTimeEntries: boolean = false;
  showMaterials: boolean = false;
  showWorkNotes: boolean = false;
  showTasks: boolean = false;
  showPhotos: boolean = false;

  includeJobChecklists: boolean = false;
  failAssetsOnly: boolean = false;

  readonly paginated$ = new BehaviorSubject<SelectableAssetType[]>([]);
  readonly types$ = new BehaviorSubject<SelectableAssetType[]>([]);

  readonly fetching$ = new BehaviorSubject<boolean>(false);

  private _onAssetTypeFetchingSubscription?: Subscription;
  private _onListChanged?: Subscription;
  private _onPageChanged?: Subscription;

  constructor(
    private readonly _api: ApiService,
    @Inject(DIALOG_DATA) private readonly _data: JobReportDialogData,
    private readonly _client: ClientStoreService,
    private readonly _view: ViewService,
    private readonly _dialog: DialogService,
    private readonly _store: PaginationStore<SelectableAssetType, number>,
  ) {}

  ngOnInit(): void {
    this._setupDefaultSettings();

    this._onAssetTypeFetchingSubscription = observe({
      before: () => this.fetching$.next(true),
      after: () => this.fetching$.next(false),
      observable: () => this._api.callPrivate$({
        action: 'post',
        path: '/record/get_unique_asset_types_by',
        body: {
          'module': this._data.module_name,
          'data': {
            ... (this._data.module_name == 'sites' && {
              'site_id': this._data.id,
            }),
            ... (this._data.module_name == 'jobs' && {
              'job_id': this._data.id,
            })
          },
        },
        onSuccessResponse: (response) => map_to_arr(response),
      }),
    })
      .pipe(
        tap(() =>
          this._onPageChanged = this._store.onNextPage$
          .pipe(
            filter(filled),
          )
          .subscribe((page) => this._store.setCurrent(new PaginatedResult({
            items: this.types$.value.slice(page * _MAX_ITEMS_PER_PAGE, (page + 1) * _MAX_ITEMS_PER_PAGE),
            pagination: new Pagination({
              next_page: when((page + 1) < Math.floor(this.types$.value.length / _MAX_ITEMS_PER_PAGE), {
                then: () => page + 1,
                else: () => null,
              }),
            }),
          })))
        )
      )
      .subscribe((types: AssetType[]) => {
        if (blank(types)) {
          this.includeJobChecklists = true;
          this.all = false;
        }

        const transformed = arr_map(types, {
          transformer: (type) => ({
            ... type,
            selected: true,
          }),
        });

        this.types$.next(transformed);
        this._store.setCurrent(new PaginatedResult({
          items: transformed.slice(0, _MAX_ITEMS_PER_PAGE),
          pagination: new Pagination({
            next_page: when(arr_count(transformed) > _MAX_ITEMS_PER_PAGE, {
              then: () => 1,
              else: () => null,
            })
          })
        }));
      });

    this._onListChanged = this._store.list$.subscribe((list) => this.paginated$.next(list));
  }

  ngOnDestroy(): void {
    if (this._onAssetTypeFetchingSubscription) {
      this._onAssetTypeFetchingSubscription.unsubscribe();
    }

    if (this._onListChanged) {
      this._onListChanged.unsubscribe();
    }

    if (this._onPageChanged) {
      this._onPageChanged.unsubscribe();
    }

    this._store.reset();
  }

  onSelectAll(checked: boolean): void {
    const selected = [... this.types$.value];

    for (const index in selected) {
      selected[index] = {
        ... selected[index],
        selected: checked,
      };
    }

    const paginated = this.paginated$.value;

    for (const index in paginated) {
      paginated[index] = {
        ... paginated[index],
        selected: checked,
      };
    }

    this.types$.next(selected);
    this.paginated$.next(paginated);
  }

  onIncludingAll(checked: boolean): void {
    this.showWorkOrder = checked;
    this.showWorkNotes = checked;
    this.showMaterials = checked;
    this.showTasks = checked;
    this.showTimeEntries = checked;
    this.includeJobChecklists = checked;
    this.showPhotos = checked;
  }

  onInclusionToggle(): void {
    this.include = this.showTasks
      && this.showWorkNotes
      && this.showWorkOrder
      && this.showMaterials
      && this.showTimeEntries
      && this.includeJobChecklists
      && this.showPhotos;
  }

  onAssetSelect(index: number, checked: boolean): void {
    if (index < 0) {
      return;
    }

    const copy = [... this.types$.value];
    const deselected = arr_some(copy, (asset) => ! asset.selected);

    if (deselected) {
      this.all = false;
    }

    copy[index] = {
      ... copy[index],
      selected: checked,
    };

    this.types$.next(copy);
  }

  onPreview = () => this._dialog.close({
    instance: this,
    result: {
      asset_type_id: arr_map(arr_filter(this.types$.value, {
        predicate: (type) => type.selected,
      }), {
        transformer: (type) => type.id,
      }),
      customer_id: data_get(this._view.getRecord(), 'customer_id'),
      show_materials: this.showMaterials,
      show_time_entries: this.showTimeEntries,
      show_work_order: this.showWorkOrder,
      show_work_notes: this.showWorkNotes,
      show_tasks: this.showTasks,
      include_job_checklists: this.includeJobChecklists,
      is_failed: this.failAssetsOnly,
      show_photos: this.showPhotos,
    },
  });

  private _setupDefaultSettings(): void {
    const client = this._client.getActiveClient();

    this.showWorkOrder = fallback(data_get(client, 'config.pdf.job_include_work_orders'), {
      fallback: () => false,
    });

    this.showTimeEntries = fallback(data_get(client, 'config.pdf.job_include_time_entries'), {
      fallback: () => false,
    });

    this.showMaterials = fallback(data_get(client, 'config.pdf.job_include_materials'), {
      fallback: () => false,
    });

    this.showWorkNotes = fallback(data_get(client, 'config.pdf.job_include_work_notes'), {
      fallback: () => false,
    });

    this.showTasks = fallback(data_get(client, 'config.pdf.job_include_tasks'), {
      fallback: () => false,
    });

    this.showPhotos = fallback(data_get(client, 'config.pdf.job_include_photos'), {
      to: () => false,
    });

    this.include = this.showTasks
      && this.showWorkNotes
      && this.showWorkOrder
      && this.showMaterials
      && this.showTimeEntries
      && this.includeJobChecklists
      && this.showPhotos;
  }
}

export type JobReportDialogData = {
  id: string;
  module_name: string;
}

type SelectableAssetType = AssetType & {
  selected: boolean;
};

const _MAX_ITEMS_PER_PAGE = 5;